<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar"/>
      <div id="select-tax-page" class="qi-content">
        <header style="display: flex; justify-content: space-between; align-items: center;">
          <h1>Seleção da Taxa do Curso</h1>
          <b style="padding: 7.5px 15px; border-radius: 70px; background-color: #FFF888;">
            <div style="display: flex">
              <span
                style="font-size: 15px; margin-top: 2.35px; margin-right: 7.5px;"
                class="material-icons"
              >
                dashboard
              </span>
              <span>
                SIMULAÇÃO
              </span>
            </div>
          </b>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-row vs-justify="left">
          <SelectedCourseBoxSimulate></SelectedCourseBoxSimulate>
          <SelectedOfferBoxSimulate></SelectedOfferBoxSimulate>
        </vs-row>

        <h3 style="margin-top: 10px">
          Taxas Disponíveis
          <span v-if="level === 'S'">- Supervisão</span>
          <span v-if="level === 'C'">- Coordenação</span>
        </h3>
        <vs-row>
          <vs-col v-for="(tax, i) in taxOptions" :key="tax.IDTAXA" vs-w="4" vs-xs="12">
            <div @click="selectTax(tax)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected: tax.IDTAXA === taxSelected.IDTAXA,
                  disabled: !tax.dueDateOptions.length,
                }"
              >
                <div class="no-flex" slot="header">
                  <h4 class="text-center">Opção {{ i + 1 }}</h4>
                  <vs-row style="margin-top: 20px;">
                    <h3>Total: R${{ tax.VALORTAXA }}</h3>
                  </vs-row>
                </div>
                <div class="spacing-children">
                  <p v-if="tax.QTDDISPONIVEL != '9999'">
                    Quantidade disponível para uso: {{ tax.QTDDISPONIVEL }}
                  </p>
                  <p>Valor Bruto: R${{ tax.VALORBRUTO }}</p>
                  <p>Desconto Aplicado: {{ tax.DESCONTO }}%</p>
                  <p>Pagamento até {{ tax.ULTIMOVENCVALIDO }}</p>
                  <vs-divider/>
                  <div>
                    <label :for="'select-' + tax.IDTAXA">
                      Data de Vencimento:
                    </label>
                    <vs-select
                      :id="'select-' + tax.IDTAXA"
                      v-model="tax.dueDate"
                      v-if="tax.dueDateOptions.length"
                      v-on:change="selectTax(tax)"
                    >
                      <vs-select-item
                        v-for="(date, index) in tax.dueDateOptions"
                        :key="index"
                        :value="date"
                        :text="date"
                      />
                    </vs-select>
                    <p v-else>Taxa Indisponível</p>
                  </div>
                </div>
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-alert
          title="Erro ao buscar as taxas do curso"
          style="margin: 15px 0;"
          color="danger"
          v-if="error"
        >
          {{ error }}
        </vs-alert>
        <h3>Formas de Pagamento Disponíveis</h3>
        <vs-row vs-justify="left">
          <vs-col
            vs-w="4"
            v-for="(payment, index) in paymentOptions"
            v-bind:key="index"
            :value="payment.IDFORMAPGTO"
          >
            <div @click="selectPayment(payment)">
              <vs-card
                class="choosable-card"
                :class="{
                  selected: payment === paymentSelected,
                }"
              >
                <div slot="header">
                  <h3 class="text-center">{{ payment.DESCRICAO.toUpperCase() }}</h3>
                </div>
                <!--<div class="spacing-children">
                  <p>Desconto: {{ payment.PERCDESC }}%</p>
                  <p>Valor final: R${{ getTaxWithDiscount(payment.PERCDESC) }}</p>
                </div>-->
              </vs-card>
            </div>
          </vs-col>
        </vs-row>
        <vs-alert
          title="Formas de Pagamento da Taxa"
          class="margin"
          color="danger"
          v-if="error2"
        >
          {{ error2 }}
        </vs-alert>

        <vs-row>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level != 'S'">
            <vs-button
              icon="refresh"
              style="width: 100%;"
              @click="updateTaxes('S')"
              type="filled"
              color="danger"
            >
              Carregar Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="!edit && level == 'S'">
            <vs-button
              icon="highlight_off"
              style="width: 100%;"
              @click="updateTaxes('V')"
              type="filled"
            >
              Remover Opções Supervisor
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level != 'C'">
            <vs-button
              icon="refresh"
              style="width: 100%;"
              @click="updateTaxes('C')"
              type="filled"
              color="danger"
              :disabled="!edit && !scholarshipCoordinator"
            >
              Carregar Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12" v-if="level == 'C'">
            <vs-button
              icon="highlight_off"
              style="width: 100%;"
              @click="updateTaxes('V')"
              type="filled"
            >
              Remover Opções Coordenador
            </vs-button>
          </vs-col>
          <vs-col vs-w="4" vs-xs="12">
            <vs-button
              icon="check_circle"
              style="width: 100%;"
              :disabled="!taxSelected.IDTAXA || !paymentSelected.IDFORMAPGTO || !taxSelected.dueDate"
              @click="goFoward()"
              type="filled"
              color="#139B0E"
            >
              Confirmar e Avançar
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </div>
  </div>
</template>
<script>
import SelectedCourseBoxSimulate from "../components/SelectedCourseBoxSimulate.vue";
import SelectedOfferBoxSimulate from "../components/SelectedOfferBoxSimulate.vue";
import {
  getStepsInformation,
  getLoginDataFromStorage,
  updateStepsInformation,
} from "../helpers/storage";
import FinancialService from "../services/financial";
import { formatDateToUSA, getDateOptions } from "../helpers";
import moment from "moment";

export default {
  name: "Tax",
  components: {
    SelectedCourseBoxSimulate,
    SelectedOfferBoxSimulate,
  },
  data: () => ({
    taxOptions: [],
    paymentOptions: [],
    profiles: [],
    scholarshipCoordinator: false,
    error: null,
    error2: null,
    paymentSelected: {},
    taxSelected: {},
    dueDate: "",
    level: "V",
    edit: false,
  }),
  mounted() {
    const { ...user } = getLoginDataFromStorage();
    this.profiles = user.profiles;

    const profileCoordinator = this.profiles.find(element => element == "SupervisorVenda");

    if(profileCoordinator) {
      this.scholarshipCoordinator = true;
    } else {
      this.scholarshipCoordinator = false;
    }

    this.$vs.loading({
      color: "danger",
    });

    const {
        offerSimulate,
        courseSimulate,
      } = getStepsInformation();
      let classificationId, qualificationId;
      classificationId = courseSimulate.IDCLASSIFICACAO;
      qualificationId = offerSimulate.IDHABILITACAOFILIAL;

    this.updateTaxes("V");
    new FinancialService()
      .getPaymentOptions(classificationId, qualificationId, "T")
      .then(({ data }) => {
        this.paymentOptions = Array.isArray(data) ? data : [data];
        this.$vs.loading.close();
      })
      .catch(({ response }) => {
        if (response && response.data) {
          this.error2 = response.data.error + '. Entre em contato com o Financeiro';
        }
        this.$vs.loading.close();
      });
  },
  methods: {
    updateTaxes(level) {
      this.taxOptions = [];
      this.level = level;
      this.$vs.loading({
        color: "danger",
      });
      const {
        offerSimulate,
        courseSimulate,
      } = getStepsInformation();
      let classificationId, qualificationId, subjectId;
      classificationId = courseSimulate.IDCLASSIFICACAO;
      qualificationId = offerSimulate.IDHABILITACAOFILIAL;
      subjectId = 0;

      new FinancialService()
        .getTaxes(
          classificationId,
          qualificationId,
          this.level,
          formatDateToUSA(new Date()),
          subjectId
        )
        .then(({ data }) => {
          const taxOptions = Array.isArray(data) ? data : [data];
          this.taxOptions = taxOptions.map((tax) => ({
            ...tax,
            dueDateOptions: getDateOptions(
              moment().startOf("day"),
              moment(tax.ULTIMOVENCVALIDO, "DD/MM/YYYY")
            ),
            dueDate: "",
          }));
          this.taxSelected = this.taxOptions[0];
          this.$vs.loading.close();
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
          this.$vs.loading.close();
        });
      this.taxSelected = {};
    },

    selectPayment(paymentMethod) {
      this.paymentSelected = paymentMethod;
    },
    selectTax(tax) {
      if (tax.dueDate) {
        this.taxSelected = tax;
      }
    },
    getTaxWithDiscount(discount) {
      if (!this.taxSelected.VALORTAXA) {
        return "0.00";
      }
      const discountNumber = Number(discount) / 100;
      const total = Number(this.taxSelected.VALORTAXA) * (1 - discountNumber);
      return total.toFixed(2);
    },
    goFoward() {
      updateStepsInformation({
        taxSimulate: this.taxSelected,
        taxPaymentSimulate: this.paymentSelected,
        taxAttendance: "Selecionou Taxa de Matrícula: R$" + this.taxSelected.VALORTAXA + ' com vencimento em ' + this.taxSelected.dueDate + ' no ' + this.paymentSelected.DESCRICAO
      });
      this.$router.push("/simulate/payment");
    },
  },
};
</script>

<style>
#select-tax-page .no-flex div.vs-col {
  flex: 0 !important;
}
#select-tax-page .text-center {
  text-align: center;
}
#select-tax-page .choosable-card {
  cursor: pointer;
}

#select-tax-page .choosable-card:hover {
  cursor: pointer;
  box-shadow: 0 0 5px 3px rgba(var(--vs-primary), 0.7);
}

#select-tax-page .choosable-card.selected {
  box-shadow: 0 0 0 2.75px rgb(var(--vs-primary)) !important;
  cursor: default;
}

#select-tax-page .choosable-card.disabled,
#select-tax-page .choosable-card.disabled:hover {
  cursor: default;
  color: #888;
  box-shadow: none;
}

#select-tax-page .spacing-children > p,
#select-tax-page .spacing-children > div {
  margin: 12px 0;
}
</style>
